import { Component, ViewChild } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import { MenuServices } from "../services";
import { Globals } from "../../../globals";
import { MenuCreateCustomizeViewPage } from "../menu-view/menu-create-customize-view";
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { MenuCreateSelectTemplatePage } from '../menu-create/menu-create-select-template/menu-create-select-template';
import { ComboListPage } from '../../combo/combo-list/combo-list';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the MenuListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-menu-list',
    templateUrl: 'menu-list.html',
})
export class MenuListPage {

    show_tutorial: boolean = false;
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' },
        { prop: 'precio', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public menuServices: MenuServices,
        public globals: Globals,
        public http: HttpClient,
        public translate: TranslateService,
        public modalCtrl: ModalController) {

        this.globals.GAtrackView('Menu', 'Menu - list', this.globals.restaurant.email, 'View', 'List menus', 'Menu', '');
        this.menuServices.getPagesMenus(0);
        if (!this.menuServices.pagesCombos) {
            this.menuServices.getPagesCombos(0);
        }
        this.menuServices.searchbar_text = '';
        //Tutorial Menu
        if (this.globals.restaurant.license == 'free') {
            this.show_tutorial = true;
        }

        if (this.globals.checkLimitsByLicense('daily_menu', 'analitycs')) {
            this.menuServices.analyticsGetMostSoldMenu();
            this.menuServices.analyticsGetHighestCommercialMarginMenu();
            this.menuServices.analyticsGetMenusSoldToday();
        }
    }

    /**********************************************************/
    /*                          INIT                          */
    /**********************************************************/

    ionViewWillEnter() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-cargando-menus')
        });
        //If para no mostrar el loader encima de la pagina del tutorial
        if (!this.show_tutorial) {
            loadingPopup.present();
        }

        // Los tags ya se cargan al inicio de la app en getAllTags()
        this.menuServices.menu_lang = this.globals.restaurant.lang;
        this.menuServices.filterMenu(this.menuServices.searchbar_text);
        loadingPopup.dismiss();
    }

    /**********************************************************/
    /*                         NAVCTRL                        */
    /**********************************************************/

    openMenuCreate() {
        this.globals.tourLaunchStep(2);
        this.navCtrl.push(MenuCreateSelectTemplatePage, {
            update_state: false,
        });
    }

    openView(menu) {
        if (menu._active) {
            this.navCtrl.push(MenuCreateCustomizeViewPage, {
                menu_uid: menu.UID,
            })
        } else {
            this.openModalVersionPro();
        }
    }

    openModalVersionPro() {
        this.navCtrl.push(AddonsTriggerVersionProPage);
    }

    openCombos() {
        this.navCtrl.push(ComboListPage, {
        });
    }

    /**********************************************************/
    /*                        FUNCIONES                       */
    /**********************************************************/

    profitFoodCost(price, extra, _foodcost) {
        /* No hace falta sumarle el extra ya que el foodcost ya lo tiene en cuenta

            var foodcost = parseFloat(extra) + parseFloat(_foodcost);
         */

        //Quitamos el tax del precio
        price = this.globals.createSubTotal(price, this.globals.RESTAURANT_TAX);
        return 100 - this.globals.regla3(parseFloat(price), _foodcost);
    }

    clickElement(event) {
        if (event.type == 'click') {
            this.openView(event.row);
        }
    }

    onSort(event) {
        var menus_array = [];
        if (this.menuServices.filteredMenusActive) {
            menus_array = this.menuServices.filteredMenus;
        } else {
            menus_array = this.menuServices.menus_array;
        }

        switch (event.column.name) {
            case 'name':
                if (event.newValue == 'asc') {
                    menus_array.sort((a, b) => this.globals.nameLangSelectMenu(a).localeCompare(this.globals.nameLangSelectMenu(b)));
                } else {
                    menus_array.sort((a, b) => this.globals.nameLangSelectMenu(b).localeCompare(this.globals.nameLangSelectMenu(a)));
                }
                break;
            case 'precio':
                if (event.newValue == 'asc') {
                    menus_array.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
                } else {
                    menus_array.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
                }
                break;
        }

        if (this.menuServices.filteredMenusActive) {
            this.menuServices.filteredMenus = menus_array;
            this.menuServices.filteredMenus = [...this.menuServices.filteredMenus];
        } else {
            this.menuServices.menus_array = menus_array;
            this.menuServices.menus_array = [...this.menuServices.menus_array];
        }
    }

    getRowClass(row) {
        return {
            'not-active': row._active === false
        };
    }
}


// WEBPACK FOOTER //
// ./src/pages/menu/menu-list/menu-list.ts